import "./TrainingCanceled.css";

export const TrainingCanceled = () => {
    return (
      <div className="training-canceled-container">
        <h2 className="important-header">WICHTIG!!!</h2>
        <p className="training-canceled-text">Das Training findet diese Woche nicht statt.</p>
      </div>
    );
  };
  